import React from 'react';
import PropTypes from 'prop-types';
import Button from 'relements/build/esm/ui/button';

// Local
import styles from './ZeroResults.scss';

const ZeroResults = ({ onCreateNewEntity, hideCreateNewEntity }) => (
  <div className={styles.container}>
    <span className={styles.title}>Can't find your entity ? </span>
    {!hideCreateNewEntity && (
      <Button onClick={onCreateNewEntity} type={Button.TYPES.SECONDARY}>
        + Create Local Entity
      </Button>
    )}
  </div>
);

ZeroResults.propTypes = {
  onCreateNewEntity: PropTypes.func,
  hideCreateNewEntity: PropTypes.bool,
};
export default ZeroResults;
